<div class="flex event-props" [ngClass]="{'flex-column': utilService.isMobile, 'body-3 text-muted': muted}"
     *ngIf="!manualWrapper">
  <ng-container [ngTemplateOutlet]="propsTemplate"></ng-container>
</div>
<ng-container *ngIf="manualWrapper" [ngTemplateOutlet]="propsTemplate"></ng-container>

<ng-template #propsTemplate>
  <div class="flex flex-wrap no-row-gap" [ngClass]="{'flex-end': alignRight}">
    <div class="info-prop" *ngIf="!hideId && eventProps.id">
      <span>
        <span class="bold">{{ 'general.api_general_id' | translate }}:</span>
        {{ eventProps.id > 1 ? eventProps.id : 'general.api_events_event_sandbox_id' }}
      </span>
    </div>
    <app-event-info-props-period [period]="eventProps.eventPeriod" *ngIf="eventProps.eventPeriod?.start" [timezone]="eventProps.timezone"
                                 [showWeekday]="showWeekday" [muted]="muted" [alignRight]="alignRight"></app-event-info-props-period>
    <ng-container *ngIf="!hideLocation">
      <div class="info-prop" *ngIf="eventProps.venueTitle?.length">
        <mat-icon class="svg-icon" [svgIcon]="'location'"></mat-icon>
        <span>{{ eventProps.venueTitle === 'api_report_show_different_venues' ? (('general.' + eventProps.venueTitle)| translate) : eventProps.venueTitle }}</span>
      </div>
      <div class="info-prop" [ngClass]="{'break-word': showFullLink}" *ngIf="eventProps.onlineLocation || displayOnlineLocationPlaceholder">
        <mat-icon class="svg-icon" [svgIcon]="'public_venues'"></mat-icon>
        <span>
          {{ displayOnlineLocationPlaceholder
          ? ('general.api_events_online_location' | translate)
          : (eventProps.onlineLocation.length > 50 && !showFullLink ? (eventProps.onlineLocation | trim: 50) + '...' : eventProps.onlineLocation) }}
        </span>
      </div>
    </ng-container>
  </div>
  <div class="flex flex-wrap no-row-gap" *ngIf="eventProps.salesPeriod?.start" [ngClass]="{'flex-end': alignRight}">
    <app-event-info-props-period [period]="eventProps.salesPeriod" [timezone]="eventProps.timezone" [showWeekday]="showWeekday" [muted]="muted"
                                 [icon]="'sales_period'" [iconTooltip]="'general.api_events_event_sale_period'" [alignRight]="alignRight"></app-event-info-props-period>
  </div>
</ng-template>
